import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><g fill="none" fillRule="evenodd"><path d="M2.275 0C1.575 0 1 .55 1 1.25v13.475c0 .7.575 1.275 1.275 1.275h11.45c.7 0 1.275-.575 1.275-1.275v-9.65L10.275 0h-8Z" fill="#F88333" fillRule="nonzero" /><text fontFamily="PingFangSC-Semibold, PingFang SC" fontSize={4} fontWeight={500} fill="#FFF"><tspan x={4} y={13}>{"PPT"}</tspan></text><path d="M10.275 0v3.65c0 .4.275 1.45 1.525 1.45H15L10.275 0Z" fill="#FFC095" fillRule="nonzero" /></g></svg>

const Ppt = React.forwardRef((props, ref) => {
  return (
    <IconBase name="ppt" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Ppt.displayName = 'IconPpt'

export default Ppt
